import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Banknote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PriceBreakdown } from "@/components/PriceBreakdown";
import { StatusBadge, PaymentBadge } from "@/components/StatusBadge";
import { api, fmtDay } from "@/lib/api";

const STEPS = ["pending", "accepted", "confirmed", "completed"];

export default function Checkout() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => {
    api.get(`/bookings/${id}`).then((r) => setB(r.data)).catch(() => setB(false));
  }, [id]);

  if (b === false) return <div className="container-x py-24 text-center" data-testid="booking-not-found">Booking not found.</div>;
  if (!b) return <div className="py-24 grid place-items-center"><Loader2 className="animate-spin" /></div>;
  const step = STEPS.indexOf(b.status);

  return (
    <div className="container-x py-10 max-w-3xl space-y-6" data-testid="checkout-page">
      <div>
        <p className="eyebrow">Booking request · Cash payment</p>
        <h1 className="text-4xl font-bold mt-1">Booking <span className="font-mono text-2xl" data-testid="checkout-booking-ref">{b.ref}</span></h1>
      </div>
      <div className="card-surface p-6 space-y-4">
        <div className="flex flex-wrap gap-2"><StatusBadge status={b.status} /><PaymentBadge status={b.payment_status} /></div>
        <p className="text-slate-700"><b>{b.companion?.display_name}</b> · {fmtDay(b.date)} · {b.start_time} IST · {b.duration_hours}h</p>
        <p className="text-sm text-slate-500">Meeting place: {b.meeting_place}</p>
        <ol className="grid grid-cols-4 gap-2 text-xs" data-testid="booking-progress">
          {STEPS.map((s, i) => <li key={s} className={`rounded-full border px-2 py-1 text-center capitalize ${i <= step ? "bg-[#0D5C46] text-white border-[#0D5C46]" : "text-slate-500"}`}>{s}</li>)}
        </ol>
        <PriceBreakdown p={b.pricing} hours={b.duration_hours} rate={b.pricing.hourly_rate} />
        <p className="text-sm rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-emerald-900 flex gap-2" data-testid="cash-payment-note">
          <Banknote size={18} className="shrink-0" />Pay ₹{b.pricing.total} in cash at the meetup, only after the companion accepts and RentMyDate confirms. Nothing is charged online; the payment is marked received only after RentMyDate staff confirm it.
        </p>
      </div>
      <Button asChild variant="outline" className="w-full h-12 rounded-full" data-testid="goto-dashboard-btn"><Link to="/dashboard">Go to my bookings</Link></Button>
    </div>
  );
}
